<div class="card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ orderType.displayName || "New Order Type" }}</div>
		<div class="ms-auto">
			<app-record-control-footer
				(onCancelChange)="onCancel()"
				(onDeleteChange)="onDelete()"
				(onSaveChange)="onSave()"
				[cancelDisabled]=""
				[deleteDisabled]="!orderType.key"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cogs']" class="me-4" size="lg"></fa-icon>
				Settings
			</ng-template>
			<app-order-type-settings [(orderType)]="orderType" [(changesToSave)]="changesToSave"></app-order-type-settings>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="orderType.atTable">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'mobile']" class="me-4" size="lg"></fa-icon>
				@table
			</ng-template>
			<app-order-type-at-table-settings [(orderType)]="orderType" [(changesToSave)]="changesToSave"></app-order-type-at-table-settings>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="orderType.kiosk">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'tablet-screen']" class="me-4" size="lg"></fa-icon>
				Kiosk
			</ng-template>
			<app-order-type-kiosk-setup [(orderType)]="orderType" [(changesToSave)]="changesToSave"></app-order-type-kiosk-setup>
		</p-tabPanel>

		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="orderType.tipped">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'hand-holding-usd']" class="me-4" size="lg"></fa-icon>
				Tips
			</ng-template>
			<app-order-type-tips [(orderType)]="orderType" [(changesToSave)]="changesToSave"></app-order-type-tips>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'paragraph']" class="me-4" size="lg"></fa-icon>
				Custom Fields
			</ng-template>
			<app-order-type-custom-fields [(orderType)]="orderType" [(changesToSave)]="changesToSave"></app-order-type-custom-fields>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'tachometer-fast']" class="me-4" size="lg"></fa-icon>
				Throttling
			</ng-template>
			<app-order-type-throttling [(orderType)]="orderType" [(changesToSave)]="changesToSave"></app-order-type-throttling>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="orderType.promptAddress">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'map-marker-check']" class="me-4" size="lg"></fa-icon>
				Delivery Zones
			</ng-template>
			<app-order-type-zones #orderTypeZones [(orderType)]="orderType" [(changesToSave)]="changesToSave"> </app-order-type-zones>
		</p-tabPanel>
	</p-tabView>
</div>
